import { ConsoleLogger } from "@core/foundation/logger";

export const logger = new ConsoleLogger("INFO");
